import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import EE from '../../../../../../../../../eventEmitter'
import { NAVIGATION_TO_SCROLL } from '../../../../../../../../../eventEmitter/constants'

import { LOCALE_PREFIX } from './constants'

import Link from './components/Link'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Navigation extends Component {
    static propTypes = {
        blocks: PropTypes.array.isRequired,
        id: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.id !== nextProps.id) return true
        if (this.props.module !== nextProps.module) return true
        if (!_.isEqual(this.props.blocks, nextProps.blocks)) return true

        return false
    }

    handleLinkClick = (blockKey) => {
        EE.emit(NAVIGATION_TO_SCROLL, blockKey)
    }

    renderLinks = () => {
        const { blocks } = this.props

        return _.map(blocks, (blockKey) => <Link key={blockKey} blockKey={blockKey} onClick={this.handleLinkClick} />)
    }

    render() {
        return (
            <div className={'portfolio-navigation-desk'}>
                <div className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.title`} />
                </div>
                <div className={'content'}>{this.renderLinks()}</div>
            </div>
        )
    }
}
